<template>
  <div class="qrcode-generator" :style="sizeStyles">
    <i v-if="isGenerating" class="el-icon-loading" />
    <i v-else-if="isFailed || !qrcodeURL" class="el-icon-warning-outline" />
    <img
      v-else-if="qrcodeURL"
      :src="qrcodeURL"
      :width="size"
      :height="size"
      decoding="async"
      alt=""
    />
  </div>
</template>

<script>
import QRCode from 'qrcode';

export default {
  name: 'QRCodeGenerator',
  props: {
    content: {
      type: String,
      default: '',
    },
    size: {
      type: Number,
      default: 100,
    },
  },
  data() {
    return {
      qrcodeURL: '',
      isGenerating: false,
      isFailed: false,
    };
  },
  computed: {
    sizeStyles() {
      return `width: ${this.size}px; height: ${this.size}px`;
    },
  },
  watch: {
    content: {
      immediate: true,
      handler: function(contentValue) {
        if (contentValue) this.generateQrCode();
      },
    },
  },
  methods: {
    async generateQrCode() {
      try {
        this.isGenerating = true;
        this.isFailed = false;
        this.qrcodeURL = await QRCode.toDataURL(this.content, {
          color: {
            light: '#0000', // Transparent background
          },
          margin: 0,
        });
      } catch (err) {
        this.isFailed = true;
      } finally {
        this.isGenerating = false;
      }
    },
  },
};
</script>

<style lang="scss">
.qrcode-generator {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #aaa;
  border-radius: 10px;

  i {
    font-size: 2rem;
  }

  img {
    flex-shrink: 0;
    width: 100%;
    height: auto;
  }
}
</style>
